import * as THREE from 'three';

export default function ColorChange(s, unif) {
    var uniforms;
    const randomColour = size => "#" + [...Array(size)].map(() => Math.floor(Math.random()*16).toString(16)).join('');
    var fragShade;
    switch (s) {
      case "christmas":
        fragShade = `
            uniform float u_time;

            vec3 colorA = vec3(0.545, 0.000, 0.000);
            vec3 colorB = vec3(0.000, 0.502, 0.000);
            vec3 colorC = vec3(1.000, 1.000, 0.878);
            
            void main() {
                vec3 color = vec3(0.0);
                vec3 colorMix = vec3(0.0);
            
                float pct = abs(sin(u_time));
            
                // Mix uses pct (a value from 0-1) to
                // mix the two colors
                color = mix(colorA, colorB, pct);
                colorMix = mix(color, colorC, pct);
            
                gl_FragColor = vec4(colorMix,1.0);
            }
            `;
        break;
      case "halloween":
        fragShade = `
            uniform float u_time;

            vec3 colorA = vec3(	0.294, 0.000, 0.510);
            vec3 colorB = vec3(0.000, 0.000, 0.000);
            vec3 colorC = vec3(1.000, 0.647, 0.000);
            
            void main() {
                vec3 color = vec3(0.0);
                vec3 colorMix = vec3(0.0);
            
                float pct = abs(sin(u_time));
            
                // Mix uses pct (a value from 0-1) to
                // mix the two colors
                color = mix(colorA, colorB, pct);
                colorMix = mix(color, colorC, pct);
            
                gl_FragColor = vec4(colorMix,1.0);
            }
            `;
        break;
      case "valentine":
        fragShade = `
            uniform float u_time;

            vec3 colorA = vec3(1.000, 0.753, 0.796);
            vec3 colorB = vec3(1.000, 0.000, 0.000);
            
            void main() {
                vec3 color = vec3(0.0);
            
                float pct = abs(sin(u_time));
            
                // Mix uses pct (a value from 0-1) to
                // mix the two colors
                color = mix(colorA, colorB, pct);
            
                gl_FragColor = vec4(color,1.0);
            }
            `;
        break;
      case "easter":
        fragShade = `
            uniform float u_time;

            vec3 colorA = vec3(1.000, 1.000, 0.000);
            vec3 colorB = vec3(0.596, 0.984, 0.596);
            
            void main() {
                vec3 color = vec3(0.0);
            
                float pct = abs(sin(u_time));
            
                // Mix uses pct (a value from 0-1) to
                // mix the two colors
                color = mix(colorA, colorB, pct);
            
                gl_FragColor = vec4(color,1.0);
            }
            `;
        break;
      case "red":
        fragShade = `
            uniform float u_time;

            vec3 colorB = vec3(1.000, 0.000, 0.000);
            
            void main() {
                gl_FragColor = vec4(colorB,1.0);
            }
            `;
        break;
      case "green":
        fragShade = `
                uniform float u_time;
    
                vec3 colorB = vec3(0.000, 1.000, 0.000);
                
                void main() {
                    gl_FragColor = vec4(colorB,1.0);
                }
                `;
        break;
      case "blue":
        fragShade = `
                uniform float u_time;
    
                vec3 colorB = vec3(0.000, 0.000, 1.000);
                
                void main() {
                    gl_FragColor = vec4(colorB,1.0);
                }
                `;
        break;
      default:
        fragShade = `
                uniform float u_time;

                void main() {
                    gl_FragColor = vec4(abs(sin(u_time)),0.0,0.344,1.0);
                }
            `;
        break;
    }
    return fragShade;
}
